import React from "react";

export const SectionLabel = ({ children, light = false }) => (
  <span
    className={`
      inline-flex items-center gap-2 text-xs font-head font-bold
      uppercase tracking-widest px-4 py-1.5 rounded-full border mb-3
      ${light
        ? "bg-blue-400/15 border-blue-400/30 text-blue-300"
        : "bg-blue-600/8 border-blue-600/15 text-blue-600"}
    `}
  >
    {children}
  </span>
);

export const SectionTitle = ({ children, light = false, center = false, className = "" }) => (
  <h2
    className={`
      font-head font-extrabold leading-[1.12] tracking-tight mb-4
      text-3xl md:text-4xl lg:text-[2.6rem]
      ${light ? "text-white" : "text-slate-900"}
      ${center ? "text-center" : ""}
      ${className}
    `}
  >
    {children}
  </h2>
);

export const SectionSub = ({ children, center = false, light = false, className = "" }) => (
  <p
    className={`
      text-base md:text-lg leading-relaxed
      ${light ? "text-white/60" : "text-slate-500"}
      ${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}
      ${className}
    `}
  >
    {children}
  </p>
);

export const CheckIcon = ({ color = "text-blue-600" }) => (
  <span className={`font-bold text-lg mt-0.5 shrink-0 ${color}`}>✓</span>
);

export const StarRating = ({ count = 5 }) => (
  <div className="flex gap-0.5">
    {[...Array(count)].map((_, i) => (
      <span key={i} className="text-amber-400 text-base">★</span>
    ))}
  </div>
);
